// extracted by mini-css-extract-plugin
export var automaticRowsSelected = "Gallery-module--automaticRowsSelected--7ffdb";
export var container = "Gallery-module--container--9f096";
export var gallerySelectorButtonsContainer = "Gallery-module--gallerySelectorButtonsContainer--8ee83";
export var gallerySelectorButtonsIndicator = "Gallery-module--gallerySelectorButtonsIndicator--c0515";
export var gallerySelectorButtonsOuterContainer = "Gallery-module--gallerySelectorButtonsOuterContainer--9c989";
export var scrollingContentSelected = "Gallery-module--scrollingContentSelected--ef8c0";